import { AxiosResponse } from 'axios';
import { API } from '../../utils/axios';
import { APIResponseStatus } from '../types';
import {
  ClientSecretResponse,
  PaymentMethodsResponse,
} from '../../features/get-care/Components/select-payment-method/types';
import { CancelCardResponse } from '../../features/get-care/types';

class PaymentSettingService {
  static getPaymentMethods(patientID: string) {
    return API.get<any, AxiosResponse<APIResponseStatus<PaymentMethodsResponse[]>>>(
      `/v1/resources/Payment/PaymentMethod/${patientID}`,
    ).then((res) => res.data);
  }

  static getClientSecret(patientID: string) {
    return API.put<any, AxiosResponse<APIResponseStatus<ClientSecretResponse>>>(
      `/v1/resources/Payment/add-card/${patientID}`,
    ).then((res) => res.data);
  }

  static cancelPayment(visitReference: string) {
    const visitReferenceNo = Number(visitReference.split('.').pop());
    return API.put<any, AxiosResponse<APIResponseStatus<CancelCardResponse>>>(
      `/v1/resources/Payment/CancelOrRefund/${visitReferenceNo}`,
    ).then((res) => res.data);
  }
}

export default PaymentSettingService;
